module.exports = ".add-container {\n  max-width: 700px;\n  margin: 0 auto; }\n  .add-container .form-inline .form-group .form-control[name=\"amount\"] {\n    width: inherit; }\n\n.input-group-addon {\n  cursor: pointer; }\n  .input-group-addon.disabled {\n    cursor: not-allowed; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/messages/import.component.scss
// module id = 572
// module chunks = 1